import { render } from "./Agreement.vue?vue&type=template&id=6367f780"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Agreement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6367f780"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6367f780', __exports__)) {
    api.reload('6367f780', __exports__)
  }
  
  module.hot.accept("./Agreement.vue?vue&type=template&id=6367f780", () => {
    api.rerender('6367f780', render)
  })

}


export default __exports__